import styled from 'styled-components'
import { backgroundOrange } from '@/theme/colors'
import { contentShell } from '@/theme/layout'
import { media } from '@/theme/tokens'

/**
 * The page's scrolling ground: the warm cream filling the layout's content
 * area, scrolling as one so the wheel works across the full viewport width.
 * Whatever must sit outside the column — a hidden file input, a full-bleed
 * banner, the page's modals — mounts here beside the PageColumn.
 */
export const PageScroll = styled.div`
	flex: 1;
	min-height: 0;
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: ${backgroundOrange};
	overflow-y: auto;
`

/**
 * The chrome's row on the shared shell: the navbar, the breadcrumb trail and
 * the public site header each sit inside a full-bleed band that owns its own
 * vertical padding and border, so they take only the column and its gutters,
 * never the page column's air above and below.
 */
export const ShellRow = styled.div`
	${contentShell}
`

/**
 * The centered content column on the shared shell (contentShell: contentWidth
 * with the chrome's 36px gutters, 18px once the bento collapses), with 40px of
 * air above and 64px below — 24/48 on the collapsed grid, 16/40 on phones. The
 * navbar, the breadcrumbs and every page share this geometry, so their edges
 * line up.
 */
export const PageColumn = styled.div`
	${contentShell}
	width: 100%;
	flex-shrink: 0;
	padding-top: 40px;
	padding-bottom: 64px;

	${media.bentoCollapse} {
		padding-top: 24px;
		padding-bottom: 48px;
	}

	${media.phone} {
		padding-top: 16px;
		padding-bottom: 40px;
	}
`

/** The page's first row: heading left, actions right; on a phone the actions drop under the heading and fill the row. */
export const PageHeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px 16px;
	flex-wrap: wrap;
	margin-bottom: 24px;

	${media.phone} {
		margin-bottom: 16px;
		gap: 8px 12px;
	}
`

export const PageActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
	flex-wrap: wrap;
	margin-left: auto;

	/* Its own line under the heading, each action stretched across it. */
	${media.phone} {
		gap: 8px;
		flex-basis: 100%;
		margin-left: 0;

		> * {
			flex: 1;
		}
	}
`
